<template>
  <div class="teaching-supply-apply">
    <div class="header">
      <div class="title">课程补修设置</div>
      <div v-if="isReady"
           class="extra">
        <el-button size="mini"
                   type="primary"
                   :loading="committing"
                   @click="handleApply">{{committing ? '提交中...' : '保存设置'}}</el-button>
      </div>
    </div>
    <div class="main">
      <div class="main-cont"
           v-loading="committing"
           element-loading-text="补修设置提交中，请稍等...">
        <TeachingSupplyApplyMain ref="main"
                                 @ready="handleReady"></TeachingSupplyApplyMain>
      </div>
    </div>
  </div>
</template>

<script>
import TeachingSupplyApplyMain from './main'
export default {
  name: 'TeachingSupplyApply',
  components: {
    TeachingSupplyApplyMain
  },
  data () {
    return {
      isReady: false,
      committing: false
    }
  },
  methods: {
    handleReady () {
      this.isReady = true
    },
    handleApply () {
      let main = this.$refs.main
      if (main) {
        main.getConfigInfo().then(result => {
          this.committing = true
          this.$ajax({
            url: '/workspace/manager/teaching/supply/apply/submitConfig',
            method: 'post',
            data: this.$qs.stringify(result)
          }).then(response => {
            if (response.data) {
              switch (response.data['responseCode']) {
                case 'SUCCESS': {
                  this.$message.success(response.data['message'])
                  break
                }
                default: {
                  this.$message.warning(response.data['message'])
                  break
                }
              }
            }
          }, () => {
            this.$message.error('请求发送失败，请稍后重试')
          }).finally(() => {
            this.committing = false
          })
        }).catch(err => {
          this.$message.warning(err.message)
        })
      }
    }
  }
}
</script>

<style lang="scss">
  .teaching-supply-apply {
    height: 100%;
    display: flex;
    flex-direction: column;
    & > .header {
      flex: none;
      position: relative;
      & > .title {
        font-size: 13px;
        text-align: center;
        background-color: #fff;
        padding: 15px;
        border-bottom: 1px solid #ebeef5;
        box-sizing: border-box;
      }
      & > .extra {
        position: absolute;
        right: 30px;
        top: 50%;
        transform: translateY(-50%);
        margin-top: -1px;
        .el-button {
          padding: 5px 15px;
          border-radius: 0;
        }
      }
    }
    & > .main {
      flex: auto;
      background-color: #fff;
      position: relative;
      & > .main-cont {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
      }
    }
  }
</style>
